<template>
  <div class="card-content">
    <form @submit.prevent="buscar">
      <div class="columns is-multiline is-variable is-1-mobile">
         <!-- Placa -->
         <div class="column is-one-fifth-desktop is-full-mobile ">
          <div class="field">
            <label class="label">Placa</label>
            <b-input
              v-model="filtro.placa"
              placeholder="Digite a Placa"
              @input="atualizarBusca"
            />
          </div>
        </div>
        <!-- Modelo -->
        <div class="column is-one-fifth-desktop is-full-mobile ">
          <div class="field">
            <label class="label">Modelo</label>
            <b-input
              v-model="filtro.modelo"
              placeholder="Digite o modelo"
              @input="atualizarBusca"
            />
          </div>
        </div>
        <!-- Classificação -->
        <div class="column is-one-fifth-desktop is-full-mobile ">
          <div class="field">
            <label class="label">Classificação</label>
            <b-select
              v-model="filtro.classificacao"
              placeholder="Classificação"
              @input="buscar"
              expanded
            >
              <option :value="null">-</option>
              <option
                v-for="(item, index) in classificacao"
                :key="index"
                :value="item.value"
              >
                {{ item.label }}
              </option>
            </b-select>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: "FilterVeiculos",
  props: {
    initialFiltro: {
      type: Object,
      default: () => ({
        empresa: null,
        placa: null,
        modelo: null,
        classificacao: null,
      }),
    },
  },
  data() {
    return {
      classificacao: [
        { label: "AUTOMOVEL", value: "AUTOMOVEL" },
        { label: "MOTOCICLETA", value: "MOTOCICLETA" },
      ],
      filtro: { ...this.initialFiltro },
      timer: null,
    };
  },
  methods: {
    atualizarBusca() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.buscar(), 500);
    },
    buscar() {
      this.$emit("filtrar", this.filtro);
    },
  },
};
</script>